<div>No Community Servers available at this time.</div>
<br />
<div>
    You can still play on a custom server or host your own.
    <a target="_blank" rel="noreferrer" href="https://youtu.be/8CTbL38eCvk"
        >How to host your own Spellmasons Server</a
    >
</div>
<div>
    Please check the
    <a target="_blank" rel="noreferrer" href="https://discord.gg/q6sUCreHeJ">
        Discord
    </a>
    for more information.
</div>
